<script setup lang="ts">
  import { computed } from 'vue';
  import { HoverListTooltip } from '@/shared/ui';
  import type { TrainingListCollaborator } from '@/entities/Training';
  import { TRAINING_EMPTY_VALUE } from '../lib/trainingEmptyValue';

  const props = defineProps<{
    collaborators: TrainingListCollaborator[];
  }>();

  const label = computed(
    () => `${props.collaborators.length} colaborador${props.collaborators.length !== 1 ? 'es' : ''}`
  );

  const title = computed(
    () => `Colaborador${props.collaborators.length !== 1 ? 'es' : ''} (${props.collaborators.length})`
  );

  const items = computed(() =>
    props.collaborators.map((collaborator) => ({ id: collaborator.id, text: collaborator.name }))
  );
</script>

<template>
  <span v-if="collaborators.length === 0">{{ TRAINING_EMPTY_VALUE }}</span>
  <HoverListTooltip
    v-else
    :label="label"
    :title="title"
    :items="items"
    test-id="training-list-collaborators-tooltip"
  />
</template>
